import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Groups = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Groups({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.5 2.25C3.5335 2.25 2.75 3.0335 2.75 4V9C2.75 9.9665 3.5335 10.75 4.5 10.75H20.5C21.4665 10.75 22.25 9.9665 22.25 9V4C22.25 3.0335 21.4665 2.25 20.5 2.25H4.5ZM4.25 4C4.25 3.86193 4.36193 3.75 4.5 3.75H20.5C20.6381 3.75 20.75 3.86193 20.75 4V5.75H4.25V4ZM4.25 7.25H20.75V9C20.75 9.13807 20.6381 9.25 20.5 9.25H4.5C4.36193 9.25 4.25 9.13807 4.25 9V7.25Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.5 13.25C3.5335 13.25 2.75 14.0335 2.75 15V20C2.75 20.9665 3.5335 21.75 4.5 21.75H20.5C21.4665 21.75 22.25 20.9665 22.25 20V15C22.25 14.0335 21.4665 13.25 20.5 13.25H4.5ZM4.25 15C4.25 14.8619 4.36193 14.75 4.5 14.75H20.5C20.6381 14.75 20.75 14.8619 20.75 15V16.75H4.25V15ZM4.25 18.25H20.75V20C20.75 20.1381 20.6381 20.25 20.5 20.25H4.5C4.36193 20.25 4.25 20.1381 4.25 20V18.25Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'groups-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Groups;
